import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PrivateLayoutComponent } from './core/layout/private-layout/private-layout.component';
import { PublicLayoutComponent } from './core/layout/public-layout/public-layout.component';

import { SpinnerModule } from '@optsolservices/ngx-spinner';
import { ForgotPasswordFormModule } from '@optsolservices/ngx-forgot-password-form';
import { LoginFormModule } from '@optsolservices/ngx-login-form';
import { SideMenuModule } from '@optsolservices/ngx-side-menu';
import { TopNavModule } from '@optsolservices/ngx-top-nav';
import { LoginComponent } from './core/components/login/login.component';
import { ForgotPasswordComponent } from './core/components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './core/components/reset-password/reset-password.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './core/services/auth.service';
import { HelperService } from './core/services/helper.service';
import { BaseService } from './core/services/base.service';
import { GeneralStoreService } from './core/store/general.store';
import { NotificationService, NotificationModule } from '@optsolservices/ngx-notification';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { SpinnerInterceptor } from './core/interceptors/spinner.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { VersionCheckerModule } from '@optsolservices/ngx-version-checker';
import { DataTableModule } from '@optsolservices/ngx-data-table';
import { DataTableWithSearchCriteriaModule } from '@optsolservices/ngx-data-table-with-search-criteria';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';

export const materialModules = [
  MatSidenavModule,
  MatDialogModule,
  MatInputModule,
  MatFormFieldModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatInputModule,
  MatSnackBarModule,
];

export const optsolModules = [
  DataTableModule.forRoot({ toolbarHeight: environment.toolbarHeight, tableMarginBottom: environment.tableMarginBottom }),
  DataTableWithSearchCriteriaModule,
  TopNavModule,
  SideMenuModule,
  VersionCheckerModule,
  NotificationModule.forRoot({
    duration: 5000,
  }),
  SpinnerModule,
  LoginFormModule,
  ForgotPasswordFormModule,
];

@NgModule({
  declarations: [
    AppComponent,
    PrivateLayoutComponent,
    PublicLayoutComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ...materialModules,
    ...optsolModules,
  ],
  providers: [
    AuthService,
    BaseService,
    HelperService,
    GeneralStoreService,
    NotificationService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
